import { render } from "./step_price.vue?vue&type=template&id=6c5d037b&scoped=true"
import script from "./step_price.vue?vue&type=script&lang=js"
export * from "./step_price.vue?vue&type=script&lang=js"

import "./step_price.vue?vue&type=style&index=0&id=6c5d037b&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5d037b"]])

export default __exports__